import { useMutation, useQueryClient } from '@tanstack/react-query';
import jwtAxios from '@libs/services/auth/src/jwt-auth';
import { useInfoViewActionsContext } from '@crema/context/InfoViewContextProvider';

export const useChannelUserMigrationMutation = () => {
  const queryClient = useQueryClient();
  const infoViewContext = useInfoViewActionsContext();

  return useMutation({
    mutationFn: async (userId: number) => {
      const { data } = await jwtAxios.post(`/api/channel-user-migration/${userId}`);
      return data;
    },
    onSuccess: () => {
      infoViewContext.showMessage('데이터 이관 신청이 완료되었습니다.');
      queryClient.invalidateQueries({ queryKey: ['/api/channel-user-migration/target-users'] });
    },
    onError: (error: any) => {
      infoViewContext.fetchApiError(error);
    },
  });
};
